import styled from "styled-components";

export const NoPredictionsText = styled.p`
  margin: auto;
  width: 100%;
  max-width: 860px;
  font-size: 18px;
  font-weight: 500;
  color: #808080;
  @media (max-width: 910px) {
    margin: 0 auto;
    width: 85%;
  }
`;
